import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

function noticePlace(notice) {
  const city = String((notice && notice.city) || '').trim();
  const state = String((notice && notice.state) || '').trim();
  if (city && state) return `${city}, ${state}`;
  return city || state || 'a new city';
}

export default function HomeMoveNotices({ profile, colors, notices, onDecide }) {
  const [rows, setRows] = useState(notices || []);
  const [busyId, setBusyId] = useState('');

  useEffect(() => {
    if (notices) {
      setRows(notices);
      return undefined;
    }
    if (!profile || !profile.id || !supabase || typeof supabase.from !== 'function') return undefined;
    let cancelled = false;
    supabase
      .from('home_move_notices')
      .select('id, homeowner_name, city, state, decision, decided_at, created_at')
      .eq('agent_id', profile.id)
      .is('decided_at', null)
      .order('created_at', { ascending: false })
      .then((result) => {
        if (cancelled || !result || result.error) return;
        setRows(result.data || []);
      });
    return () => {
      cancelled = true;
    };
  }, [profile, notices]);

  if (!rows.length) return null;

  const decide = async (notice, decision) => {
    setBusyId(notice.id);
    try {
      if (onDecide) {
        await onDecide(notice, decision);
      } else {
        const { error } = await supabase
          .from('home_move_notices')
          .update({ decision })
          .eq('id', notice.id);
        if (error) throw error;
      }
      setRows((current) => current.filter((row) => row.id !== notice.id));
    } catch (error) {
      console.error('Could not save the move decision', error);
    } finally {
      setBusyId('');
    }
  };

  return (
    <div data-testid="home-move-notices" style={{ marginBottom: '1.5rem' }}>
      {rows.map((notice) => {
        const who = String(notice.homeowner_name || '').trim() || 'A homeowner';
        return (
          <div
            key={notice.id}
            style={{
              background: colors.surface,
              border: `1px solid ${colors.border}`,
              borderRadius: '0.75rem',
              padding: '1rem',
              marginBottom: '0.75rem',
              color: colors.text,
            }}
          >
            <h3 style={{ margin: '0 0 0.35rem', fontSize: '1.05rem' }}>{who} is moving</h3>
            <p style={{ margin: '0 0 0.85rem', color: colors.textSecondary, lineHeight: 1.45 }}>
              {who} is moving to a new home in {noticePlace(notice)}. The new street address is not shown. Keeping them is the default.
            </p>
            <div style={{ display: 'flex', gap: '0.6rem', flexWrap: 'wrap' }}>
              <button
                type="button"
                disabled={busyId === notice.id}
                onClick={() => decide(notice, 'keep')}
                style={{
                  minHeight: '48px',
                  padding: '0.7rem 1rem',
                  border: 'none',
                  borderRadius: '0.75rem',
                  background: '#59c4c4',
                  color: '#fff',
                  fontWeight: 700,
                  fontFamily: 'inherit',
                  cursor: 'pointer',
                }}
              >
                Keep
              </button>
              <button
                type="button"
                disabled={busyId === notice.id}
                onClick={() => decide(notice, 'release')}
                style={{
                  minHeight: '48px',
                  padding: '0.7rem 1rem',
                  borderRadius: '0.75rem',
                  border: `1px solid ${colors.border}`,
                  background: 'transparent',
                  color: colors.text,
                  fontWeight: 650,
                  fontFamily: 'inherit',
                  cursor: 'pointer',
                }}
              >
                Release
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
